//  Location detail
analytics.eventConfig.push({
    "target": ".gdl-detail",
    "codeId": "prd",
    "events": [
        {
            "eventTarget": ".gdl-detail-phone",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "ldcl",
                "componentName": "row locator details contact link",
                "eventType": [
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "location click to email"
                    },
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('fax:')",
                        "value": "location click to fax"
                    },
                    {
                        "rule": true,
                        "value": "location click to call"
                    }
                ],
                "elementType": [
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "email link"
                    },
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('fax:')",
                        "value": "fax link"
                    },
                    {
                        "rule": true,
                        "value": "phone number link"
                    }
                ],
                "searchType": "locator-details",
                "titleText": ""
            }
        },
        {
            "eventTarget": ".gdl-detail-email",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "ldcl",
                "componentName": "row locator details contact link",
                "eventType": [
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "location click to email"
                    },
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('fax:')",
                        "value": "location click to fax"
                    },
                    {
                        "rule": true,
                        "value": "location click to call"
                    }
                ],
                "elementType": [
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "email link"
                    },
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('fax:')",
                        "value": "fax link"
                    },
                    {
                        "rule": true,
                        "value": "phone number link"
                    }
                ],
                "searchType": "locator-details",
                "titleText": ""
            }
        },
        {
            "eventTarget": ".gdl-detail-url",
            "eventType": "click",
            "tags": {
                "componentId": "ldwl",
                "componentName": "row locator details website link",
                "eventType": "location website outbound click",
                "elementType": "location website link",
                "elementText": "",
                "event": "locator",
                "destinationUrl": "",
                "searchType": "locator-details",
                "titleText": ""
            }
        }
    ]
});